module.exports = __webpack_public_path__ + "img/full_banner.ba98792d.jpg";